import { Marriage } from 'shell/models/person/marriage';
import { transformCitizen } from '../citizenship-shared';
import { transformEventData } from '../event-datas-shared';
import { transformGenerality } from '../registry-office/generality';
import { AccordionMarriage } from 'shell/view-models/accordion-marriage';
import { ActType } from 'shell/constants/act-type';
import { transformDocumentDigital } from '../shared/transform-document-digital';

export const transformMarriageAnpr05 = (
  values: AccordionMarriage | undefined
): Marriage | undefined => {
  if (!values) {
    return undefined;
  }

  const { isForeign, eventDate, eventChoiceDate, exceptionalLocation } = values || {};

  const coniuge = transformGenerality(values?.generality || null, values?.person || null);

  const withCittadinanza = Boolean(
    values?.citizenship?.value ||
      values?.citizenship?.id ||
      values?.citizenshipCode ||
      values?.note ||
      values?.from
  );

  const cittadinanza = withCittadinanza
    ? transformCitizen({
        citizenship: values?.citizenship?.value || '',
        code: values?.citizenship?.id || values?.citizenshipCode || '',
        note: values?.note,
        validityDate: values?.from?.toFormat('dd/MM/yyyy') || '',
      })
    : undefined;

  const datiMatrimonio = transformEventData({
    isForeign,
    eventDate,
    eventChoiceDate,
    exceptionalLocation,
    location: {
      exceptionalLocation: values?.exceptionalLocation || '',
      localita:
        (!values?.isForeign
          ? values?.italian?.location
          : values?.foreign?.municipality?.description) || '',
      foreignState: values?.foreign?.state,
      municipality: values?.italian?.municipality,
    },
  });

  const withActPaper =
    values?.paper?.actYear ||
    values?.paper?.actPart ||
    values?.paper?.actSeries ||
    values?.paper?.actNumber ||
    values?.paper?.actVolume ||
    values?.paper?.actDate ||
    values?.paper?.actMunicipality?.description ||
    values?.paper?.actMunicipality?.id ||
    values?.paper?.actMunicipality?.province;

  const attoDigitale =
    values?.actType === ActType.AttoDigitale
      ? transformDocumentDigital(values?.digital || undefined)
      : undefined;

  const originReturnData: Marriage | undefined =
    datiMatrimonio || coniuge || cittadinanza || withActPaper || attoDigitale
      ? {
          coniuge,
          cittadinanza,
          datiMatrimonio: datiMatrimonio
            ? {
                ...(datiMatrimonio || {}),
                attoEventoANPR:
                  values?.actType === ActType.SenzaAtto
                    ? undefined
                    : withActPaper || attoDigitale
                    ? {
                        atto:
                          withActPaper && values?.actType === ActType.AttoCartaceo
                            ? {
                                anno: values?.paper?.actYear || undefined,
                                parte: values?.paper?.actPart || undefined,
                                serie: values?.paper?.actSeries || undefined,
                                numeroAtto: values?.paper?.actNumber || undefined,
                                volume: values?.paper?.actVolume || undefined,
                                dataFormazioneAtto:
                                  values?.paper?.actDate?.toFormat('yyyy-MM-dd') || undefined,
                                trascritto: values?.paper?.transcribed ? '1' : undefined,
                                comuneRegistrazione: values?.paper?.actMunicipality
                                  ? {
                                      nomeComune:
                                        values?.paper?.actMunicipality?.description || undefined,
                                      codiceIstat: values?.paper?.actMunicipality?.id || undefined,
                                      siglaProvinciaIstat:
                                        values?.paper?.actMunicipality?.province || undefined,
                                    }
                                  : undefined,
                              }
                            : undefined,
                        attoANSC:
                          values?.actType === ActType.AttoDigitale ? attoDigitale : undefined,
                      }
                    : undefined,
              }
            : undefined,
          ordineMatrimonio: values?.number?.toString() || undefined,
        }
      : undefined;

  return originReturnData;
};
